import { http } from './http';
import { ROUTES } from './config';
import type { PermissionCell } from '../types/domain';

/** PermissionsController client — admin only. */
export const permissionsApi = {
  get(): Promise<PermissionCell[]> {
    return http.get(ROUTES.permissions);
  },

  update(cell: { module: string; action: string; role: string; allowed: boolean }): Promise<void> {
    return http.put(ROUTES.permissions, cell);
  },
};
